import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/product-10.jpg'
import _imports_1 from '@/assets/images/product-11.jpg'
import _imports_2 from '@/assets/images/product-12.jpg'


const _hoisted_1 = { class: "sidebar-wedget-wrap" }
const _hoisted_2 = { class: "sidebar-wedget" }
const _hoisted_3 = { class: "ps-0 mb-0 list-unstyled categories" }
const _hoisted_4 = { class: "sidebar-wedget" }
const _hoisted_5 = { class: "ps-0 mb-0 list-unstyled popular-post" }
const _hoisted_6 = { class: "sidebar-wedget" }
const _hoisted_7 = { class: "ps-0 mb-0 list-unstyled popular-tags d-flex flex-wrap gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[20] || (_cache[20] = _createStaticVNode("<div class=\"sidebar-wedget\"><span class=\"top-title\">بحث في المقالات</span><form class=\"search-form position-relative z-1\"><input type=\"text\" class=\"form-control\" placeholder=\"ابحث هنا...\"><button class=\"src-btn position-absolute top-50 end-0 translate-middle-y\"><i class=\"ri-search-line\"></i></button></form></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "top-title" }, "التصنيفات", -1)),
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, {
            to: "/categories",
            class: "d-flex justify-content-between align-items-center"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "d-flex align-items-center" }, [
                _createElementVNode("i", { class: "ri-arrow-right-s-fill" }),
                _createElementVNode("span", { class: "name" }, "تلفزيون الستلايت")
              ], -1),
              _createElementVNode("span", { class: "count" }, "(11)", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, {
            to: "/categories",
            class: "d-flex justify-content-between align-items-center"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "d-flex align-items-center" }, [
                _createElementVNode("i", { class: "ri-arrow-right-s-fill" }),
                _createElementVNode("span", { class: "name" }, "تكنولوجيا البث")
              ], -1),
              _createElementVNode("span", { class: "count" }, "(09)", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, {
            to: "/categories",
            class: "d-flex justify-content-between align-items-center"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "d-flex align-items-center" }, [
                _createElementVNode("i", { class: "ri-arrow-right-s-fill" }),
                _createElementVNode("span", { class: "name" }, "حلول مشاكل الشبكة")
              ], -1),
              _createElementVNode("span", { class: "count" }, "(14)", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, {
            to: "/categories",
            class: "d-flex justify-content-between align-items-center"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createElementVNode("div", { class: "d-flex align-items-center" }, [
                _createElementVNode("i", { class: "ri-arrow-right-s-fill" }),
                _createElementVNode("span", { class: "name" }, "حماية اشتراكات IPTV")
              ], -1),
              _createElementVNode("span", { class: "count" }, "(15)", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, {
            to: "/categories",
            class: "d-flex justify-content-between align-items-center"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "d-flex align-items-center" }, [
                _createElementVNode("i", { class: "ri-arrow-right-s-fill" }),
                _createElementVNode("span", { class: "name" }, "الأعمال والتجارة")
              ], -1),
              _createElementVNode("span", { class: "count" }, "(03)", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, {
            to: "/categories",
            class: "d-flex justify-content-between align-items-center"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createElementVNode("div", { class: "d-flex align-items-center" }, [
                _createElementVNode("i", { class: "ri-arrow-right-s-fill" }),
                _createElementVNode("span", { class: "name" }, "البث المباشر (Streaming)")
              ], -1),
              _createElementVNode("span", { class: "count" }, "(24)", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "top-title" }, "المقالات الشائعة", -1)),
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, {
            to: "/product-details",
            class: "d-flex align-items-center"
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createElementVNode("div", { class: "flex-shrink-0" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "blog"
                })
              ], -1),
              _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
                _createElementVNode("h4", null, "أفضل أجهزة التوجيه (Router) لتشغيل سيرفرات IPTV بدون تقطيع"),
                _createElementVNode("span", { class: "text-body" }, "25.00 €")
              ], -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, {
            to: "/product-details",
            class: "d-flex align-items-center"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createElementVNode("div", { class: "flex-shrink-0" }, [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: "blog"
                })
              ], -1),
              _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
                _createElementVNode("h4", null, "كيفية إعداد وتشغيل الاشتراكات على الشاشات الذكية (Smart TV)"),
                _createElementVNode("span", { class: "text-body" }, "10.00 €")
              ], -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, {
            to: "/product-details",
            class: "d-flex align-items-center"
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createElementVNode("div", { class: "flex-shrink-0" }, [
                _createElementVNode("img", {
                  src: _imports_2,
                  alt: "blog"
                })
              ], -1),
              _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
                _createElementVNode("h4", null, "أهم 10 نصائح لتسريع جودة البث المباشر للمباريات الكبرى"),
                _createElementVNode("span", { class: "text-body" }, "24 يناير، 2026")
              ], -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[19] || (_cache[19] = _createElementVNode("span", { class: "top-title" }, "الوسوم الشائعة", -1)),
      _createElementVNode("ul", _hoisted_7, [
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, { to: "/tags" }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode("أعمال", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, { to: "/tags" }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode("تطبيقات", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, { to: "/tags" }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
              _createTextVNode("سيرفرات", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, { to: "/tags" }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createTextVNode("حماية الشبكة", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, { to: "/tags" }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
              _createTextVNode("إنترنت سريع", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, { to: "/tags" }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
              _createTextVNode("شاشات ذكية", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, { to: "/tags" }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createTextVNode("نصائح البث", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, { to: "/tags" }, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
              _createTextVNode("بث مباشر", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}